{
  "0_ALREADY_EXISTS": "\"{0}\" sudah wujud.",
  "0_OF_1": "{0} daripada {1}",
  "ACCOUNT_ID": "ID Akaun",
  "ADD": "Menambah",
  "ADD_REMOVE_FIELDS": "Tambah/alih keluar medan",
  "AN_ERROR_OCCURED": "Ralat berlaku",
  "APPLY": "Memohon",
  "APPLY_CHANGES": "Gunakan perubahan",
  "ATTACH": "Melampirkan",
  "ATTACH_AS_LINK": "Lampirkan sebagai Pautan",
  "ATTACHING": "Melampirkan...",
  "AUTOMATICALLY_RENAME": "Namakan semula secara automatik",
  "BACK": "Kembali",
  "BROWSE": "Layari",
  "CANCEL": "Batal",
  "CHARACTER_COUNT": "Kiraan aksara:",
  "CLOSE": "Tutup",
  "CLOUD": "Awan",
  "COMMENT": "Komen",
  "CONFIGURE_REPOSITORY_SETTINGS": "Konfigurasikan Tetapan Repositori",
  "COULD_NOT_SAVE_0": "Tidak dapat menyelamatkan \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Tidak dapat menyelamatkan \"{0}\". Jenis fail tidak disokong.",
  "DATA": "Data",
  "DATE": "Tarikh",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Medan tarikh mestilah dalam format {0}.",
  "DATE_PROVIDED_IS_INVALID": "Tarikh yang diberikan adalah tidak sah.",
  "DATE_TIME": "Tarikh/Masa",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Medan tarikh/masa mestilah dalam format {0}.",
  "DEFAULT_FOLDER": "<Folder Lalai>",
  "DETAILS": "Butiran",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Adakah anda mahu menggunakan perubahan medan anda?",
  "DOCUMENT_NAME_IS_EMPTY": "Nama dokumen kosong",
  "DRAG_DROP_FILE": "Seret dan lepas fail",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Entri bernama '{0}' sudah wujud dalam folder ini. Sila pilih nama lain.",
  "ENTRY_ID": "ID Kemasukan",
  "ENTRY_NAME": "Nama Penyertaan",
  "ENTRY_NOT_FOUND": "Entri tidak dijumpai.",
  "ERROR_DOWNLOADING_DOCUMENT": "Ralat memuat turun dokumen.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Ralat berlaku semasa menyambung ke pelayan.",
  "ERROR_SAVING": "Penjimatan ralat:",
  "FAILED_TO_OPEN_FOLDER": "Gagal membuka folder",
  "FAILED_TO_SAVE_COLON": "Gagal menyimpan:",
  "FAILED_TO_SAVE_PERIOD": "Gagal menyimpan.",
  "FEEDBACK": "Maklum balas",
  "FIELDS": "Bidang",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Fail ini melebihi saiz fail maksimum 25MB.",
  "FILE_EXTENSION": "Pelanjutan Fail",
  "FILE_LOCKED": "Fail dikunci.",
  "FILE_MODIFIED": "Fail Diubah suai",
  "FILE_NAME": "Nama fail",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Nama fail tidak boleh mengandungi garis miring terbalik",
  "FOLDER": "Folder",
  "INTEGER": "Integer",
  "LIST": "Senarai",
  "LOADING": "Memuatkan...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Medan panjang mestilah integer antara 0 dan 3,999,999,999",
  "LONG_INTEGER": "Integer Panjang",
  "NAME": "Nama",
  "NAME_CONFLICT": "Konflik Nama",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Perlukan bantuan untuk log masuk? Hubungi Pentadbir Laserfiche anda untuk mendapatkan bantuan.",
  "NEW_FOLDER": "Folder Baru",
  "NO": "Tidak",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Tiada medan tambahan yang ditetapkan",
  "NO_FOLDER_SELECTED": "Tiada folder dipilih.",
  "NO_MATCHING_ENTRIES_FOUND": "Tiada penyertaan yang sepadan ditemui",
  "NO_MATCHING_FIELDS_FOUND": "Tiada medan padanan ditemui.",
  "NO_TEMPLATE_ASSIGNED": "Tiada templat diberikan",
  "NOT_AVAILABLE_WITH_TOKENS": "Tidak tersedia dengan token",
  "NUMBER": "Nombor",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Medan nombor mestilah nombor yang sah",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Satu atau lebih medan tidak sah.",
  "OPEN": "Terbuka",
  "OPEN_IN_LASERFICHE": "Buka dalam Laserfiche",
  "OPTIONAL": "Pilihan",
  "OR": "Atau",
  "PARENT_FIELD": "Medan Induk",
  "PARENT_ID": "ID Ibu Bapa",
  "PARENT_NAME": "Nama Ibu Bapa",
  "PLEASE_SELECT_A_FOLDER": "Sila pilih folder",
  "REASON_FOR_DOWNLOADING": "Sebab Muat Turun",
  "REFRESH": "Refresh",
  "REMOVE": "Mengalih keluar",
  "REMOVE_REPOSITORY": "Alih keluar Repositori?",
  "REPOSITORY": "Repositori",
  "REPOSITORY_COUNT": "Kiraan Repositori",
  "REPOSITORY_ID": "ID repositori",
  "REPOSITORY_NAME": "Nama repositori",
  "REQUIRED": "Diperlukan",
  "REQUIRED_FIELD_IS_EMPTY": "Medan yang diperlukan kosong",
  "SAVE_CHANGES": "Simpan Perubahan",
  "SAVE_TO_LASERFICHE": "Simpan ke Laserfiche",
  "SAVED_TO_LASERFICHE": "Disimpan ke Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Disimpan ke Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Disimpan dengan metadata yang hilang:",
  "SAVING": "Menyimpan...",
  "SEARCH_FIELDS": "Medan carian",
  "SELECT": "Pilih",
  "SELECT_REASON": "Pilih sebab",
  "SELF_HOSTED": "Dihoskan sendiri",
  "SESSION_COUNT": "Kiraan Sesi",
  "SETTINGS": "Seting",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Medan pendek mestilah integer antara 0 dan 64999",
  "SIGN_IN": "Dafar masuk",
  "SIGN_IN_TO_LASERFICHE": "Log masuk ke Laserfiche",
  "SIGN_OUT": "Log keluar",
  "SIGNING_IN": "Log masuk...",
  "SIGNING_OUT": "Log keluar...",
  "SKIP_THIS_FILE": "Langkau fail ini",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Ada sesuatu yang tidak kena. Sila cuba lagi kemudian.",
  "SUBMIT": "Hantar",
  "SUGGESTION": "Cadangan",
  "TEMPLATE": "Template",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Templat telah gagal dimuatkan.",
  "TEXT": "Teks",
  "THANK_YOU_FOR_SUBMISSION": "Terima kasih atas penyerahan anda!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Medan ini mempunyai panjang maksimum yang dibenarkan {0} Aksara.",
  "THIS_FOLDER_IS_EMPTY": "Folder ini kosong.",
  "TIME": "Masa",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Medan masa mestilah dalam format {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Tidak dapat memuatkan semua medan:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Tidak dapat mendapatkan semula maklumat repositori:",
  "UNKNOWN_ERROR": "Ralat Tidak Diketahui.",
  "USER_NAME": "Nama Pengguna",
  "YES": "Ya"
}
